class ArlyNavPanelElement extends HTMLElement {
	get header() {
		return this.closest("#header");
	}

	get target() {
		return document.querySelector(this.getAttribute("target"));
	}

	connectedCallback() {
		this.addEventListener("mouseenter", () => {
			this.header.querySelectorAll(".nav-panel-open")
			.forEach(panel => {
				panel.classList.remove("nav-panel-open");
			});

			this.target.classList.add("nav-panel-open");

			this.header.classList.add("nav-panel-open");
		});

		this.header.addEventListener("mouseleave", () => {
			this.target.classList.remove("nav-panel-open");
			this.header.classList.remove("nav-panel-open");
		});
	}
}

customElements.define('arly-nav-panel', ArlyNavPanelElement);